import { Api } from '../api';
import { customer } from '../endpoints';
import type { ApiResponse } from '../../models';
import type { UpdateCustomerDetailsRequest } from './models';

export class CustomerApi extends Api {
  static updateCustomerDetails = (data: UpdateCustomerDetailsRequest, signal?: AbortSignal) =>
    this.post<UpdateCustomerDetailsRequest, ApiResponse<undefined>>({ url: customer.updateCustomerDetails(), data, signal });
}
